(function () {
  const header = () => {
    const header = document.querySelector(".shopify-section-header");
    const menu = document.querySelector(".list-menu--inline");
    const menuLinks = document.querySelectorAll(".list-menu-item");
    const search = document.querySelector(".header__search");

    let hideMenuTimeout;

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search.isOpen) {
        search.close();
      }
    });

    const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        document.documentElement.style.setProperty(
          "--ann-height",
          `${entry.intersectionRect.height}px`
        );
      } else {
        document.documentElement.style.setProperty("--ann-height", `0px`);
      }
    });
    if (annBar) annBarObserver.observe(annBar);

    const megaMenus = document.querySelectorAll(".mega-menu");

    // Disable click for # links in desktop inline menu
    const disableHashLinks = () => {
      const isDesktop = window.matchMedia("(min-width: 1200px)").matches;
      if (isDesktop && menu) {
        const menuItems = menu.querySelectorAll(".header__menu-item");
        menuItems.forEach((menuItem) => {
          // Skip if already processed
          if (menuItem.dataset.hashDisabled) return;

          const href = menuItem.getAttribute("href");
          if (!href) return;

          // Check if href is #, ends with #, or contains only hash
          const hrefTrimmed = href.trim();
          // Remove query params and check if ends with #
          const hrefWithoutQuery = hrefTrimmed.split("?")[0];
          const isHashLink =
            hrefTrimmed === "#" ||
            hrefTrimmed === "#/" ||
            hrefWithoutQuery.endsWith("#") ||
            hrefWithoutQuery.endsWith("#/") ||
            /^#\/?$/.test(hrefTrimmed) ||
            /^\/.*#\/?$/.test(hrefWithoutQuery);

          if (isHashLink) {
            menuItem.dataset.hashDisabled = "true";
            menuItem.addEventListener(
              "click",
              (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
              },
              { passive: false, capture: true }
            );
          }
        });
      }
    };

    // Disable navigation for # links in mobile menu (but allow collapsible to work)
    const disableMobileHashLinks = () => {
      const isMobile = !window.matchMedia("(min-width: 1200px)").matches;
      if (isMobile) {
        const mobileMenuLinks = document.querySelectorAll(
          ".menu-drawer__menu-link, .menu-drawer__menu-item[href]"
        );
        mobileMenuLinks.forEach((menuLink) => {
          // Skip if already processed
          if (menuLink.dataset.mobileHashDisabled) return;

          const href = menuLink.getAttribute("href");
          if (!href) return;

          // Check if href is #, ends with #, or contains only hash
          const hrefTrimmed = href.trim();
          const hrefWithoutQuery = hrefTrimmed.split("?")[0];
          const isHashLink =
            hrefTrimmed === "#" ||
            hrefTrimmed === "#/" ||
            hrefWithoutQuery.endsWith("#") ||
            hrefWithoutQuery.endsWith("#/") ||
            /^#\/?$/.test(hrefTrimmed) ||
            /^\/.*#\/?$/.test(hrefWithoutQuery);

          if (isHashLink) {
            menuLink.dataset.mobileHashDisabled = "true";
            // Only prevent navigation, allow summary/details to work
            menuLink.addEventListener(
              "click",
              (e) => {
                // Prevent navigation but allow the event to bubble to summary
                e.preventDefault();
                // Don't stop propagation so summary can still toggle details
                return false;
              },
              { passive: false }
            );
          }
        });
      }
    };

    // Run on load
    disableHashLinks();
    disableMobileHashLinks();

    // Re-run on resize to handle mobile/desktop switch
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        disableHashLinks();
        disableMobileHashLinks();
      }, 250);
    });

    // Re-run when mobile menu opens (for dynamically loaded content)
    const headerDrawer = document.querySelector("header-drawer");
    if (headerDrawer) {
      const observer = new MutationObserver(() => {
        disableMobileHashLinks();
      });
      observer.observe(headerDrawer, {
        childList: true,
        subtree: true,
      });
    }

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        clearTimeout(hideMenuTimeout);

        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");

          if (!megaMenus) return;
          megaMenus.forEach((megaMenu) => {
            const megaMenuPositionRight =
              megaMenu.getBoundingClientRect().right;
            const windowRight = window.innerWidth;
            if (megaMenuPositionRight > windowRight) {
              megaMenu.style.right = "0";
            }
            if (megaMenu == link.querySelector(".mega-menu")) {
              megaMenu.style.opacity = 0;
              megaMenu.style.display = "grid";
              setTimeout(() => {
                megaMenu.style.opacity = 1;
              }, 100);
            }
          });

          menuLinks.forEach((el) => {
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
            }
          });
        } else {
          menuLinks.forEach((el) => {
            el.classList.remove("list-menu--megamenu-visible");
          });
        }
      });
      link.addEventListener("mouseleave", (e) => {
        if (link.classList.contains("list-menu--megamenu")) {
          if (!megaMenus) return;
          megaMenus.forEach((megaMenu) => {
            if (megaMenu == link.querySelector(".mega-menu")) {
              megaMenu.style.opacity = 0;
              hideMenuTimeout = setTimeout(() => {
                megaMenu.style.display = "none";
              }, 100);
            }
          });
        }
      });
      link.addEventListener("focus", (e) => {
        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");

          if (!megaMenus) return;
          megaMenus.forEach((megaMenu) => {
            const megaMenuPositionRight =
              megaMenu.getBoundingClientRect().right;
            const windowRight = window.innerWidth;
            if (megaMenuPositionRight > windowRight) {
              megaMenu.style.right = "0";
            }
          });

          menuLinks.forEach((el) => {
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
            }
          });
        } else {
          menuLinks.forEach((el) => {
            el.classList.remove("list-menu--megamenu-visible");
          });
        }
      });
    });
    menu.addEventListener("mouseleave", (e) => {
      if (!megaMenus) return;
      setTimeout(() => {
        megaMenus.forEach((megaMenu) => {
          megaMenu.style.right = "auto";
        });
      }, 500);
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu--megamenu-visible");
      });
    });
    menu.addEventListener("focusout", (e) => {
      if (!megaMenus) return;
      setTimeout(() => {
        megaMenus.forEach((megaMenu) => {
          megaMenu.style.right = "auto";
        });
      }, 500);
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu--megamenu-visible");
      });
    });

    const megaMenuTabs = () => {
      $(".mega-menu__tab-wrapper")
        .children()
        .find(".mega-menu__tab-wrapper")
        .first()
        .addClass("mega-menu__tab-wrapper--active");
      $(".mega-menu__tab-wrapper").mouseenter(function (event) {
        $(".mega-menu__tab-wrapper").removeClass(
          "mega-menu__tab-wrapper--active"
        );
        $(this).addClass("mega-menu__tab-wrapper--active");
      });
      $(".mega-menu__tab-wrapper").focus(function (event) {
        $(".mega-menu__tab-wrapper").removeClass(
          "mega-menu__tab-wrapper--active"
        );
        $(this).addClass("mega-menu__tab-wrapper--active");
      });
      $(".mega-menu__tab-wrapper").focusin(function (event) {
        $(".mega-menu__tab-wrapper").removeClass(
          "mega-menu__tab-wrapper--active"
        );
        $(this).addClass("mega-menu__tab-wrapper--active");
      });
    };
    megaMenuTabs();

    const main = document.querySelector("main");
    const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
    if (
      main.querySelectorAll(".shopify-section")[0] &&
      main
        .querySelectorAll(".shopify-section")[0]
        .classList.contains("section--has-overlay")
    ) {
    }

    const menuCloseBtn = document.querySelector(".header__modal-close-button");
    const mobileMenuDrawer = document.querySelector("header-drawer");
    menuCloseBtn.addEventListener("click", (e) => {
      mobileMenuDrawer.closeMenuDrawer(e);
    });
  };

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);

  header();
})();
